import { type GetServerSideProps } from 'next';
import SignInWithOkta from '@/components/Account/SignInWithOkta/SignInWithOkta';

export default function Login() {
  return <SignInWithOkta />;
}

export const getServerSideProps: GetServerSideProps = async context => {
  // If user is already logged in, redirect to dashboard
  const accessToken = context.req.cookies['okta-access-token'];

  if (accessToken) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    };
  }

  return {
    props: {},
  };
};
